import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dedication } from 'models/Dedication'

const initialState: Dedication = {
  hasDedication: false,
  type: 'honor',
  honoreeFirstName: '',
  honoreeLastName: '',
  honoreeName: '',
  recipientFirstName: '',
  recipientLastName: '',
  recipientName: '',
  recipientEmailAddress: '',
  recipientAddress: '',
  recipientCity: '',
  recipientState: '',
  recipientPostalCode: '',
  recipientCountry: '',
  isGiftAmountMessageIncluded: false,
  ecardMessage: '',
  selectedEcardId: undefined,
}

export const dedicationSlice = createSlice({
  name: 'dedication',
  initialState,
  reducers: {
    setDedication: (_state, action: PayloadAction<Dedication>) => {
      return action.payload
    },
    // Reducer to clear the dedication all at once
    clearDedication: () => {
      return initialState
    },
  },
})

export const { setDedication, clearDedication } = dedicationSlice.actions

export default dedicationSlice.reducer
